/* eslint-disable no-underscore-dangle */
import urlsService from '@/services/urls-service';
import { appInsights } from '@/telemetry/client';
import { api } from './api-service';

interface IVatNumberRequest {
  vatRegistrationNr: string;
}

interface IVatNumberResponse {
  valid: boolean;
  vatRegistrationNr: string;
  companyName: string;
  address: IAddress;
}

interface ICocNumberLookup {
  registrationNr: string;
}

interface ICocAddress {
  street: string;
  houseNumber: string;
  houseNumberAddition?: string;
  postalCode: string;
  city: string;
}

interface ICocNumberLookupResponse {
  cocNumber: string;
  companyName: string;
  active: boolean;
  address?: ICocAddress;
}

export const vatNumberLookup = async ({ vatRegistrationNr }: IVatNumberRequest) =>
  api.get<IVatNumberResponse>({
    url: `${urlsService.getUrl('/vat')}?vatNumber=${vatRegistrationNr}`
  });

export const cocNumberLookup = async ({ registrationNr }: ICocNumberLookup) => {
  if (!registrationNr) {
    console.log('no registrationNr');
    return;
  }

  try {
    const url = urlsService.getUrl('/coc', { queryParams: { cocNumber: registrationNr } });

    const data = await api.get<ICocNumberLookupResponse>({ url });

    if (data) {
      if (!data.address) {
        // The result is still valid, but no address data is available
        return {
          companyName: data.companyName || ''
        };
      }

      return {
        companyName: data.companyName || '',
        postalCode: data.address.postalCode || '',
        houseNumber: data.address.houseNumber || '',
        city: data.address.city || '',
        street: data.address.street || ''
      };
    }
  } catch (error) {
    console.log(error);
    appInsights.trackException({ exception: new Error(error as any) });
  }
};
